<dl class="space-y-3 py-1 lg:pr-6">
  @if (ticket().Service_Location_Address__c) {
    <div
      class="grid grid-cols-1 items-start gap-y-1 lg:grid-cols-[88px_1fr] lg:gap-x-4"
    >
      <dt
        class="font-lato shrink-0 pt-0.5 text-xs font-semibold tracking-[0.06em] text-gray-400 uppercase"
      >
        Location
      </dt>
      <dd class="font-lato text-sm leading-snug break-words">
        {{ ticket().Service_Location_Address__c }}
      </dd>
    </div>
  }

  @if (ticket().Service__r?.Name) {
    <div
      class="grid grid-cols-1 items-start gap-y-1 lg:grid-cols-[88px_1fr] lg:gap-x-4"
    >
      <dt
        class="font-lato shrink-0 pt-0.5 text-xs font-semibold tracking-[0.06em] text-gray-400 uppercase"
      >
        Service
      </dt>
      <dd class="min-w-0">
        <span class="font-lato text-sm leading-snug break-words">
          <span class="font-bold">{{ ticket().Service__r.Name }}</span>
          @if (ticket().Service__r.RecordType?.Name) {
            <span aria-hidden="true"> · </span
            >{{ ticket().Service__r.RecordType.Name }}
          }
          @if (ticket().Service__r.Bandwidth_Downstream__c) {
            <span aria-hidden="true"> · </span
            >{{ ticket().Service__r.Bandwidth_Downstream__c }}
            @if (ticket().Service__r.Asymmetrical_Bandwidth__c) {
              <span aria-hidden="true">/</span
              >{{ ticket().Service__r.Bandwidth_Upstream__c }}
            }
          }
          @if (ticket().Service__r.Vendor__r) {
            <span aria-hidden="true"> · </span
            >{{
              ticket().Service__r.Vendor__r.Display_Alias__c ||
                ticket().Service__r.Vendor__r.Name
            }}
          }
        </span>
      </dd>
    </div>
  }

  @if (
    ticket().Customer_Ticket_Number__c &&
    ticket().RecordType.Name !== TicketRecordType.Care
  ) {
    <div
      class="grid grid-cols-1 items-start gap-y-1 lg:grid-cols-[88px_1fr] lg:gap-x-4"
    >
      <dt
        class="font-lato shrink-0 pt-0.5 text-xs font-semibold tracking-[0.06em] text-gray-400 uppercase"
      >
        <abbr title="Customer number">Customer #</abbr>
      </dt>
      <dd class="font-lato text-sm leading-snug break-words">
        {{ ticket().Customer_Ticket_Number__c }}
      </dd>
    </div>
  }

  @if (ticket().Description) {
    <div
      class="grid grid-cols-1 items-start gap-y-1 lg:grid-cols-[88px_1fr] lg:gap-x-4"
    >
      <dt
        class="font-lato shrink-0 pt-0.5 text-xs font-semibold tracking-[0.06em] text-gray-400 uppercase"
      >
        Description
      </dt>
      <dd class="min-w-0">
        <p
          id="ticket-description"
          class="font-lato m-0 text-sm leading-relaxed whitespace-pre-line"
          [class.line-clamp-3]="!showFullDescription()"
        >
          {{ ticket().Description }}
        </p>
        @if (isDescriptionLong()) {
          <button
            type="button"
            class="font-lato mt-1 text-sm font-semibold text-blue-600 hover:text-blue-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700"
            [attr.aria-expanded]="showFullDescription()"
            aria-controls="ticket-description"
            (click)="toggleDescription()"
          >
            {{ showFullDescription() ? 'View less' : 'View more' }}
          </button>
        }
      </dd>
    </div>
  }
</dl>
